import React, { useEffect, useState, useCallback } from 'react'
import { isEmpty } from 'lodash'
import FILTERED_TYPE from '../constant'
import { showActiveFilters } from '../helpers/helpersTable'
import { showActiveFiltersPivot } from '../helpers/helpersPivot'
import { getDefaultFilter, isNameAlreadyStored } from '../storeUtils'
import LoadingModal from '../../LoadingModal'
import TextInput from '../../TextInput'
import ActiveFilters from '../../ActiveFilters'

const TableSaveFilterModal = ({ open, close, data }) => {
  const {
    tabular,
    tableApi,
    onSave,
    t,
    type,
    // identifier,
    linksByUri,
    userId,
    kind,
    id,
    userPreferences
  } = data
  const [columnsInfo, setColumnsInfo] = useState([])
  const [pivotFilterInfo, setPivotFilterInfo] = useState({})
  const [isInvalidName, setIsInvalidName] = useState(false)
  const [isWarnName, setIsWarnName] = useState(false)
  const [filterName, setFilterName] = useState('')
  const [ubliqueLinks, setUbliqueLinks] = useState([])

  useEffect(() => {
    if (open) {
      if (type === FILTERED_TYPE.TABLE) {
        if (typeof linksByUri === 'function') {
          setUbliqueLinks(linksByUri())
        }
      }
    }
  }, [open])

  useEffect(() => {
    if (tableApi) {
      if (type === FILTERED_TYPE.PIVOT) {
        setColumnsInfo(tableApi.gridCore.columnApi.getColumnState())
        setPivotFilterInfo(tableApi.gridCore.filterManager.getFilterModel())
      } else {
        setColumnsInfo(tableApi.gridCore.filterManager.getFilterModel())
      }
    }
  }, [tableApi])

  const onSaveModal = () => {
    if (!filterName || isEmpty(filterName)) {
      setIsInvalidName(true)
      return
    }

    if (
      isNameAlreadyStored({
        filterName,
        type,
        // identifier,
        userId,
        kind,
        userPreferences,
        id
      })
    ) {
      setIsWarnName(true)
    }

    onSave(filterName, columnsInfo, type)
    close()
  }
  const onChange = ({ target: { value } }) => {
    setFilterName(value)
    isEmpty(value) ? setIsInvalidName(true) : setIsInvalidName(false)

    setIsWarnName(
      isNameAlreadyStored({
        filterName: value,
        type,
        // identifier,
        userId,
        kind,
        userPreferences,
        id
      })
    )
  }

  const onClose = () => {
    close()
    setIsInvalidName(false)
    setIsWarnName(false)
  }

  const customHeaderModal = useCallback(() => {
    return (
      <div className='modal-header bx--modal-header__heading'>
        <h4>{t('FilterMenu.ColumnsFilterButtonTable.TITLE')}</h4>
      </div>
    )
  }, [t])

  const renderBody = () => {
    if (type === FILTERED_TYPE.PIVOT) {
      return (
        <div>
          <ActiveFilters
            filters={showActiveFiltersPivot(columnsInfo, tableApi, t)}
            labels={{ subtitle: t('columns') }}
          />
          <ActiveFilters
            filters={showActiveFilters(pivotFilterInfo, tableApi)}
            labels={{ subtitle: t('filters') }}
          />
          <ActiveFilters
            filters={
              isEmpty(columnsInfo) && isEmpty(pivotFilterInfo)
                ? {}
                : {
                    [t('TableActions.Tabular.TABULAR')]: tabular
                      ? [t('TableActions.Tabular.ACTIVE')]
                      : [t('TableActions.Tabular.NOT_ACTIVE')]
                  }
            }
            labels={{ subtitle: t('TableActions.Tabular.TABLE') }}
          />
        </div>
      )
    }
    return (
      <ActiveFilters
        filters={showActiveFilters(columnsInfo, tableApi, ubliqueLinks)}
        labels={{ subtitle: t('columns') }}
      />
    )
  }

  useEffect(() => {
    const name =
      getDefaultFilter(
        { id, userId, /*  identifier, */ type, kind },
        userPreferences()
      ).name ?? ''

    setFilterName(name)
    name !== '' && setIsWarnName(true)
  }, [])

  return (
    <LoadingModal
      size='md'
      open={open}
      onRequestClose={onClose}
      onRequestSubmit={onSaveModal}
      secondaryButtonText={t('Translations:Cancel')}
      primaryButtonText={t('Translations:Save')}
      modalHeading={customHeaderModal()}
      className='columnsFilter-modal-inputview'
      preventCloseOnClickOutside
    >
      <TextInput
        id='filterName'
        defaultValue={filterName}
        labelText={t('FilterMenu.ColumnsFilterButtonTable.INPUT_TITLE')}
        placeholder={t('FilterMenu.ColumnsFilterButtonTable.INPUT_PLACEHOLDER')}
        invalidText={t('FilterMenu.ColumnsFilterButtonTable.INVALID_INPUT')}
        invalid={isInvalidName}
        warn={isWarnName}
        warnText={t('FilterMenu.ColumnsFilterButtonTable.WARNING_INPUT', {
          filterName: filterName
        })}
        onChange={onChange}
        autoComplete='off'
      />
      {renderBody()}
    </LoadingModal>
  )
}

export default TableSaveFilterModal
